// let urls = 'http://192.168.101.11:8080'
// let urls = 'http://127.0.0.1:8080'
// let urls = 'http://36.7.89.102:8080'
let urls = 'http://121.229.189.13:8099'
//let urls = 'http://localhost:100'

 class Https {
 	request(url, method, data) {
 		return new Promise((resolve, reject) => {
 			$.ajax({
 				url: urls + url,
 				type: method,
 				async: true,
 				data,
				// dataType: "json",
				// contentType: "application/json;charset=utf-8",
 				success: function(res) {
 					if (res.code == 200) {
 						resolve(res)
 					}
 				}
 			})
 		})
 	}
	submit(url, formData) {
		return new Promise((resolve, reject) => {
			$.ajax({
				url: urls + url,
				type: 'POST',
				async: true,
				data: formData,
				dataType: "json",
				contentType: "application/json;charset=utf-8",
				success: function(res) {
					if (res.code == 200) {
						resolve(res)
					}
				}
			})
		})
	}
 	up(url, formData) {
 		return new Promise((resolve, reject) => {
 			$.ajax({
 				url: urls + url,
 				type: 'POST',
 				data: formData,
 				processData: false,
 				contentType: false,
 				async: true,
 				dataType: "json",
 				success: function(res) {
 					if (res.code == 200) {
 						resolve(res)
 					}
 				}
 			})
 		})
 	}
 	get(url, data) {
		console.log(url)
 		return this.request(url, 'GET', data)
		
 	}
 	post(url, data) {
 		return this.request(url, 'POST', data)
 	}
 	put(url, data) {
 		return this.request(url, 'PUT', data)
 	}
 }

 const https = new Https()

 export default {
 	https,
 	urls
 }
